// Kho hướng dẫn — gộp từ các nhóm menu.
//
// Khoá là id trang trong `components/sidebar/nav-items.ts`. Bài kiểm
// `coverage.test.ts` đối chiếu hai bên, nên thêm mục menu mà quên viết hướng
// dẫn là đỏ ngay.

import type { GuideBook } from "../types";
import { OVERVIEW_GUIDES } from "./overview";
import { ORDERS_MONEY_GUIDES } from "./orders-money";
// Hàng chờ duyệt báo giá doanh nghiệp (QĐ 0178) — trang riêng cạnh Đơn hàng.
import { QUOTE_APPROVALS_GUIDES } from "./quote-approvals";
// Trang Thanh toán ở file riêng: bài của nó chia theo chín thẻ nên dài gấp
// nhiều lần bài một trang thường.
import { PAYMENT_GUIDES } from "./payment";
import { STUDIO_GUIDES } from "./studio";
import { CSKH_GUIDES } from "./cskh";
import { COMPLAINTS_GUIDES } from "./complaints";
// Khiếu nại (QĐ 0201) — một trang HAI THẺ: sổ Tiếng khách và phiếu khiếu nại.
// Gộp 25/09/2026; trước đó là ba mục menu rời (`customer_voice`, `complaints`,
// `cskh_complaint`) với ba bài riêng.
import { CATALOG_GUIDES } from "./catalog";
import { HR_GUIDES } from "./hr";
// Trang Nhân sự ở file riêng, cùng lý do với trang Thanh toán: bài chia theo
// thẻ của màn nên dài gấp nhiều lần bài một trang thường.
import { STAFF_DIRECTORY_GUIDES } from "./staff-directory";
// Năng suất nhân sự (QĐ 0386) — màn của người theo dõi đội, không của nhân viên.
import { STAFF_PRODUCTIVITY_GUIDES } from "./staff-productivity";
// Ba trang ca ở file riêng, cùng lý do với trang Thanh toán: bài chia theo thẻ
// của màn nên dài gấp nhiều lần bài một trang thường.
import { BRANCH_SHIFT_GUIDES } from "./branch-shift";
import { HALF_DAY_SLOT_GUIDES } from "./half-day-slots";
import { SET_BOARD_GUIDES } from "./set-board";
import { WARDROBE_LOOKUP_GUIDES } from "./wardrobe-lookup";
import { LETAN_SHIFT_GUIDES } from "./letan-shift";
import { EKIP_SHIFT_GUIDES } from "./ekip-shift";
import { REPORTS_SETTINGS_GUIDES } from "./reports-settings";
// Chống gian lận (QĐ 0216) — file riêng vì bài này là NGOẠI LỆ THỨ HAI ở cổng
// lọc, sau `salary_rules_v2`. Để lẫn vào nhóm khác là ngoại lệ đó khó thấy.
import { fraudBoardGuide } from "./fraud-board";
// Hộp thư kín Tố giác & Góp ý (QĐ 0272) — trang người gửi và trang người đọc.
import { SEALED_INBOX_GUIDES } from "./sealed-inbox";
import { HUNCH_ROOM_GUIDES } from "./hunch-room";
// Khoản chi của tôi (QĐ 0283) — nhân viên tự khai khoản chi gửi Kế toán.
import { EXPENSE_CLAIMS_GUIDES } from "./expense-claims";
import { STAFF_CHANNEL_GUIDES } from "./staff-channel";
import { ME_GUIDES } from "./me";
// Thông báo của tôi (20/10/2026) — hộp thư của chính người đăng nhập.
import { MY_NOTIFICATIONS_GUIDES } from "./my-notifications";

// Mượn / trả đồ (CEO chốt 08/10/2026) — máy quét ngay trong GNPF, lệnh qua Center về kho.
import { KHO_BORROW_GUIDES } from "./kho-borrow";
// Phòng Kinh doanh (QĐ 0483, CEO 17a 28/10/2026).
import { SALES_TEAM_GUIDES } from "./sales-team";
// Bàn làm việc QC (QĐ 0521, 03/11/2026).
import { QC_DESK_GUIDES } from "./qc-desk";

export const GUIDE_BOOK: GuideBook = {
  ...OVERVIEW_GUIDES,
  ...ORDERS_MONEY_GUIDES,
  ...QUOTE_APPROVALS_GUIDES,
  ...PAYMENT_GUIDES,
  ...STUDIO_GUIDES,
  ...CSKH_GUIDES,
  ...COMPLAINTS_GUIDES,
  ...CATALOG_GUIDES,
  ...HR_GUIDES,
  ...STAFF_DIRECTORY_GUIDES,
  ...STAFF_PRODUCTIVITY_GUIDES,
  ...BRANCH_SHIFT_GUIDES,
  ...HALF_DAY_SLOT_GUIDES,
  ...SET_BOARD_GUIDES,
  ...WARDROBE_LOOKUP_GUIDES,
  ...LETAN_SHIFT_GUIDES,
  ...EKIP_SHIFT_GUIDES,
  ...REPORTS_SETTINGS_GUIDES,
  fraud_board: fraudBoardGuide,
  ...SEALED_INBOX_GUIDES,
  ...HUNCH_ROOM_GUIDES,
  ...EXPENSE_CLAIMS_GUIDES,
  ...STAFF_CHANNEL_GUIDES,
  ...ME_GUIDES,
  ...KHO_BORROW_GUIDES,
  ...MY_NOTIFICATIONS_GUIDES,
  ...SALES_TEAM_GUIDES,
  ...QC_DESK_GUIDES,
};
